export class ClientAttributes {
}
/**
 * Construct that holds a map of charts -> brokers -> selected attributes
 */
export class ChartAttributeMaps {
    constructor() {
        this.chartToBrokerAttributeMap = new Map();
        this.chartToClientAttributeMap = new Map();
        for (let i = 1; i <= ChartAttributeMaps.NUMBER_OF_CHARTS; i++) {
            this.chartToBrokerAttributeMap.set(i, new Map());
            this.chartToClientAttributeMap.set(i, new Map());
        }
    }
    //Set the map for chartid to brokerid to attributes 
    setAttributesToChartBroker(chartId, brokerId, attributes) {
        this.chartToBrokerAttributeMap.get(chartId).set(brokerId, attributes);
    }
    //Set the map for chartid to brokerid to clients and attributes 
    setAttributesToChartBrokerClients(chartId, brokerId, clientAttributes) {
        this.chartToClientAttributeMap.get(chartId).set(brokerId, clientAttributes);
    }
    //Set the map for chartid to brokerid to clients and retains Attributes 
    setClientsToChartBrokerAttributes(chartId, brokerId, clients) {
        if (!this.chartToClientAttributeMap.get(chartId).get(brokerId))
            this.chartToClientAttributeMap.get(chartId).set(brokerId, new ClientAttributes());
        this.chartToClientAttributeMap.get(chartId).get(brokerId).clients = clients;
    }
    //Set the attributes for chartid to brokerid to clients and retains Attributes 
    setAttributesToChartBrokerClient(chartId, brokerId, attributes) {
        if (!this.chartToClientAttributeMap.get(chartId).get(brokerId))
            this.chartToClientAttributeMap.get(chartId).set(brokerId, new ClientAttributes());
        this.chartToClientAttributeMap.get(chartId).get(brokerId).attributes = attributes;
    }
    //reset the chart id to broker id map
    resetChartToBrokerAttributeMap(chartId) {
        this.chartToBrokerAttributeMap.set(chartId, new Map());
    }
    //reset the chart id to broker id ClientAttribute map
    resetChartToBrokerClientsAttributeMap(chartId) {
        this.chartToClientAttributeMap.set(chartId, new Map());
    }
    //reset all maps
    resetMaps(chartId) {
        this.resetChartToBrokerAttributeMap(chartId);
        this.resetChartToBrokerClientsAttributeMap(chartId);
    }
    //get the chart to broker map
    getChartToBrokerMap(chartId) {
        return this.chartToBrokerAttributeMap.get(chartId);
    }
    //get attributes for a chart's broker
    getAttributesForChartsBroker(chartId, brokerId) {
        return this.chartToBrokerAttributeMap.get(chartId).get(brokerId);
    }
    //get attributes for a chart's broker
    getClientAttributesForChartsBroker(chartId, brokerId) {
        return this.chartToClientAttributeMap.get(chartId).get(brokerId).attributes;
    }
    getChartsForBroker(brokerToFind) {
        let chartIds = [];
        this.chartToBrokerAttributeMap.forEach((brokersToAttr, chartId) => {
            brokersToAttr.forEach((attrs, brokerId) => {
                if (brokerId == brokerToFind && attrs.length > 0) {
                    chartIds.push(chartId);
                }
            });
        });
        return chartIds;
    }
    getChartsForClientBroker(brokerToFind, client) {
        let chartIds = [];
        this.chartToClientAttributeMap.forEach((brokersToClientsAttr, chartId) => {
            brokersToClientsAttr.forEach((clientAttrs, brokerId) => {
                if (brokerId == brokerToFind && clientAttrs.clients.length > 0 && clientAttrs.clients.find((_client) => _client == client)) {
                    chartIds.push(chartId);
                }
            });
        });
        return chartIds;
    }
    //Function to check if the broker has atleast one attribute set
    isABrokerAttributeSet() {
        let hasAttr = false;
        this.chartToBrokerAttributeMap.forEach((brokersToAttr, chartId) => {
            brokersToAttr.forEach((attrs, brokerId) => {
                if (attrs && attrs.length > 0) {
                    hasAttr = true;
                    return;
                }
            });
        });
        this.chartToClientAttributeMap.forEach((brokersToAttr, chartId) => {
            brokersToAttr.forEach((clientAttrs, brokerId) => {
                if (clientAttrs && clientAttrs.clients.length > 0 && clientAttrs.attributes.length > 0) {
                    hasAttr = true;
                    return;
                }
            });
        });
        return hasAttr;
    }
    //get a map of broker ids to every attribute across all the charts that map the broker
    getBrokerToAttributesMap() {
        let brokerToAttributeMap = new Map();
        this.chartToBrokerAttributeMap.forEach((brokersToAttr) => {
            brokersToAttr.forEach((attrs, brokerId) => {
                if (!brokerToAttributeMap.has(brokerId)) {
                    brokerToAttributeMap.set(brokerId, attrs);
                }
                else {
                    let existingAttrs = [...brokerToAttributeMap.get(brokerId)];
                    attrs.forEach(attr => {
                        if (!existingAttrs.includes(attr))
                            existingAttrs.push(attr);
                    });
                    brokerToAttributeMap.set(brokerId, existingAttrs);
                }
            });
        });
        return brokerToAttributeMap;
    }
    //get a map of broker ids to every client attribute across all the charts that map the broker clients
    getBrokerToClientAttributesMap() {
        let brokerToClientAttributeMap = new Map();
        this.chartToClientAttributeMap.forEach((brokersToClientAttr) => {
            brokersToClientAttr.forEach((clientAttrs, brokerId) => {
                if (!brokerToClientAttributeMap.has(brokerId)) {
                    brokerToClientAttributeMap.set(brokerId, Object.assign({}, clientAttrs));
                }
                else {
                    let existingAttrs = brokerToClientAttributeMap.get(brokerId);
                    clientAttrs.clients.forEach(client => {
                        if (!existingAttrs.clients.includes(client))
                            existingAttrs.clients.push(client);
                    });
                    clientAttrs.attributes.forEach(client => {
                        if (!existingAttrs.attributes.includes(client))
                            existingAttrs.attributes.push(client);
                    });
                }
            });
        });
        return brokerToClientAttributeMap;
    }
}
//Hard limit on the number of charts
ChartAttributeMaps.NUMBER_OF_CHARTS = 5;
//context key for the svelte construct
ChartAttributeMaps.CONTEXT_KEY = "CHART_TO_BROKER_ATTRIBUTE_MAP";
